<template>
  <div
    class="com_selection-box"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RadioSelection',
}
</script>
